/* PACKS R US theme.js — vanilla, native Shopify AJAX cart + quick-add + PDP */
(function () {
  "use strict";

  function money(cents) { return "$" + (cents / 100).toFixed(2); }
  function esc(s) {
    return String(s == null ? "" : s).replace(/&/g, "&amp;").replace(/</g, "&lt;").replace(/>/g, "&gt;").replace(/"/g, "&quot;");
  }

  /* ---------------- toast ---------------- */
  function toast(title, desc) {
    var stack = document.getElementById("ToastStack");
    if (!stack) { stack = document.createElement("div"); stack.id = "ToastStack"; document.body.appendChild(stack); }
    var t = document.createElement("div");
    t.className = "toast";
    t.innerHTML = "<b></b><span></span>";
    t.querySelector("b").textContent = title || "";
    t.querySelector("span").textContent = desc || "";
    stack.appendChild(t);
    setTimeout(function () { t.remove(); }, 2200);
  }
  window.pruToast = toast;

  /* ---------------- generic sheets (menu / cart / quick-add) ---------------- */
  function openSheet(name) {
    var ov = document.querySelector('[data-sheet-overlay="' + name + '"]');
    var sh = document.querySelector('[data-sheet="' + name + '"]');
    if (ov) ov.setAttribute("data-open", "true");
    if (sh) sh.setAttribute("data-open", "true");
  }
  function closeSheet(name) {
    var ov = document.querySelector('[data-sheet-overlay="' + name + '"]');
    var sh = document.querySelector('[data-sheet="' + name + '"]');
    if (ov) ov.setAttribute("data-open", "false");
    if (sh) sh.setAttribute("data-open", "false");
  }
  function closeAllSheets() { ["menu", "cart", "quickadd"].forEach(closeSheet); }

  /* ---------------- cart ---------------- */
  function getCart() { return fetch("/cart.js", { headers: { Accept: "application/json" } }).then(function (r) { return r.json(); }); }

  function renderCart(cart) {
    document.querySelectorAll("[data-cart-count]").forEach(function (el) {
      el.textContent = cart.item_count;
      if (cart.item_count > 0) el.removeAttribute("hidden"); else el.setAttribute("hidden", "");
    });
    var sub = document.querySelector("[data-cart-subtitle]");
    if (sub) sub.textContent = cart.item_count === 0 ? "Your cart is empty" : cart.item_count + " item" + (cart.item_count !== 1 ? "s" : "") + " in your cart";

    var body = document.querySelector("[data-cart-lines]");
    var foot = document.querySelector("[data-cart-foot]");
    if (!body) return;
    if (!cart.items || cart.items.length === 0) {
      body.innerHTML = '<div style="flex:1;display:flex;align-items:center;justify-content:center;padding:4rem 0"><div style="text-align:center"><p class="text-muted">Your cart is empty</p></div></div>';
      if (foot) foot.style.display = "none";
      return;
    }
    var html = "";
    cart.items.forEach(function (item) {
      var opts = (item.options_with_values || []).map(function (o) { return o.value; }).filter(function (v) { return v && v !== "Default Title"; }).join(" • ");
      html +=
        '<div class="cart-line">' +
          '<div class="cart-line__img">' + (item.image ? '<img src="' + item.image + '" alt="' + esc(item.product_title) + '">' : "") + "</div>" +
          '<div class="cart-line__body">' +
            '<h4 class="cart-line__name">' + esc(item.product_title) + "</h4>" +
            (opts ? '<p class="cart-line__opts">' + esc(opts) + "</p>" : "") +
            '<p class="cart-line__price">' + money(item.price) + "</p>" +
          "</div>" +
          '<div class="cart-line__ctrls">' +
            '<button class="icon-btn-sm" data-line-remove="' + item.key + '" aria-label="Remove">✕</button>' +
            '<div class="qty-box">' +
              '<button class="qty-btn" data-line-key="' + item.key + '" data-line-qty="' + (item.quantity - 1) + '" aria-label="Decrease">−</button>' +
              '<span style="width:2rem;text-align:center;font-size:14px">' + item.quantity + "</span>" +
              '<button class="qty-btn" data-line-key="' + item.key + '" data-line-qty="' + (item.quantity + 1) + '" aria-label="Increase">+</button>' +
            "</div>" +
          "</div>" +
        "</div>";
    });
    body.innerHTML = '<div style="padding:1.5rem">' + html + "</div>";
    if (foot) {
      foot.style.display = "block";
      var total = foot.querySelector("[data-cart-total]");
      if (total) total.textContent = money(cart.total_price);
    }
  }

  function refreshCart() { return getCart().then(renderCart); }

  function addToCart(variantId, qty) {
    return fetch("/cart/add.js", {
      method: "POST",
      headers: { "Content-Type": "application/json", Accept: "application/json" },
      body: JSON.stringify({ items: [{ id: variantId, quantity: qty || 1 }] }),
    }).then(function (r) {
      if (!r.ok) return r.json().then(function (e) { throw new Error(e.description || "Could not add"); });
      return r.json();
    }).then(function () { return refreshCart(); });
  }

  function changeLine(key, qty) {
    return fetch("/cart/change.js", {
      method: "POST",
      headers: { "Content-Type": "application/json", Accept: "application/json" },
      body: JSON.stringify({ id: key, quantity: qty }),
    }).then(function (r) { return r.json(); }).then(renderCart)
      .catch(function () { toast("Error", "Could not update cart"); });
  }

  /* ---------------- quick-add ---------------- */
  var qaState = { product: null, variantId: null, qty: 1, imgIdx: 0 };

  function openQuickAdd(handle) {
    fetch("/products/" + handle + ".js", { headers: { Accept: "application/json" } })
      .then(function (r) { return r.json(); })
      .then(function (p) {
        qaState.product = p;
        qaState.variantId = (p.variants.filter(function (v) { return v.available; })[0] || p.variants[0]).id;
        qaState.qty = 1; qaState.imgIdx = 0;
        renderQuickAdd();
        openSheet("quickadd");
      })
      .catch(function () { toast("Error", "Could not load product"); });
  }

  function renderQuickAdd() {
    var p = qaState.product; if (!p) return;
    var root = document.querySelector('[data-sheet="quickadd"] [data-qa-content]');
    if (!root) return;
    var variant = p.variants.filter(function (v) { return v.id === qaState.variantId; })[0] || p.variants[0];
    var images = p.images || [];
    var hero = images[qaState.imgIdx] || images[0] || "";
    var showVariants = p.variants.length > 1;

    var dots = images.length > 1 ? '<div class="qa-dots" data-qa-dots>' + images.map(function (src, i) {
      return '<button class="qa-dot ' + (i === qaState.imgIdx ? "is-active" : "") + '" data-qa-dot="' + i + '" aria-label="Image ' + (i + 1) + '"></button>';
    }).join("") + "</div>" : "";

    var variantBtns = showVariants ? '<div style="display:flex;flex-direction:column;gap:0.75rem">' +
      '<p class="qa-eyebrow">Select Option</p><div class="qa-opts">' +
      p.variants.map(function (v) {
        return '<button class="qa-opt ' + (v.id === qaState.variantId ? "is-active" : "") + '" data-qa-variant="' + v.id + '">' + esc(v.title) + "</button>";
      }).join("") + "</div></div>" : "";

    root.innerHTML =
      '<div class="qa-hero">' +
        '<div class="qa-carousel" data-qa-track>' +
          (images.length ? images.map(function (src) { return '<div class="qa-cslide"><img src="' + src + '" alt="' + esc(p.title) + '"></div>'; }).join("") : "") +
        "</div>" +
        '<span class="qa-corner qa-corner--tl-v"></span><span class="qa-corner qa-corner--tl-h"></span>' +
        '<span class="qa-corner qa-corner--br-v"></span><span class="qa-corner qa-corner--br-h"></span>' +
        dots +
      "</div>" +
      '<div class="qa-details">' +
        '<div style="display:flex;flex-direction:column;gap:0.75rem">' +
          '<p class="qa-eyebrow">Atelier Edit</p>' +
          '<h2 class="qa-name">' + esc(p.title) + "</h2>" +
          '<div class="qa-divider"><span></span><span class="qa-star">✦</span><span></span></div>' +
          '<p class="qa-price">' + money(variant.price) + "</p>" +
        "</div>" +
        (p.description ? '<p class="qa-desc">' + p.description.replace(/<[^>]*>/g, "") + "</p>" : "") +
        variantBtns +
        '<div style="display:flex;flex-direction:column;gap:0.75rem">' +
          '<p class="qa-eyebrow">Quantity</p>' +
          '<div style="display:flex;justify-content:center"><div class="qa-qty">' +
            '<button data-qa-qty="-1" aria-label="Decrease">−</button>' +
            '<span data-qa-qtyval>' + ("0" + qaState.qty).slice(-2) + "</span>" +
            '<button data-qa-qty="1" aria-label="Increase">+</button>' +
          "</div></div>" +
        "</div>" +
        '<div class="qa-services">' +
          '<div class="qa-service"><svg viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2"><rect x="1" y="3" width="15" height="13"/><path d="M16 8h4l3 3v5h-7V8z"/><circle cx="5.5" cy="18.5" r="2.5"/><circle cx="18.5" cy="18.5" r="2.5"/></svg><p>Complimentary Shipping</p></div>' +
          '<div class="qa-service"><svg viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2"><path d="M3 2v6h6"/><path d="M21 12A9 9 0 0 0 6 5.3L3 8"/><path d="M21 22v-6h-6"/><path d="M3 12a9 9 0 0 0 15 6.7l3-2.7"/></svg><p>30-Day Returns</p></div>' +
          '<div class="qa-service"><svg viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2"><path d="M12 22s8-4 8-10V5l-8-3-8 3v7c0 6 8 10 8 10z"/></svg><p>Authenticity Assured</p></div>' +
        "</div>" +
      "</div>";

    var foot = document.querySelector('[data-sheet="quickadd"] [data-qa-foot]');
    if (foot) foot.innerHTML =
      '<button class="qa-add" data-qa-add><svg viewBox="0 0 24 24" width="16" height="16" fill="none" stroke="currentColor" stroke-width="2"><path d="M6 2 3 6v14a2 2 0 0 0 2 2h14a2 2 0 0 0 2-2V6l-3-4z"/><path d="M3 6h18"/><path d="M16 10a4 4 0 0 1-8 0"/></svg> Add to Bag</button>' +
      '<a class="qa-viewfull" href="/products/' + p.handle + '">View Full Details</a>';

    initQACarousel();
  }

  function initQACarousel() {
    var track = document.querySelector('[data-sheet="quickadd"] [data-qa-track]');
    if (!track) return;
    var imgs = (qaState.product && qaState.product.images) || [];
    var dots = document.querySelectorAll('[data-sheet="quickadd"] [data-qa-dot]');
    // restore to the current image once the sheet has layout
    requestAnimationFrame(function () { track.scrollLeft = qaState.imgIdx * track.clientWidth; });
    var raf;
    track.addEventListener("scroll", function () {
      if (raf) cancelAnimationFrame(raf);
      raf = requestAnimationFrame(function () {
        var i = Math.round(track.scrollLeft / track.clientWidth);
        i = Math.max(0, Math.min(imgs.length - 1, i));
        qaState.imgIdx = i;
        dots.forEach(function (d, idx) { d.classList.toggle("is-active", idx === i); });
      });
    }, { passive: true });
  }

  /* ---------------- PDP ---------------- */
  function initPDP() {
    var root = document.querySelector("[data-pdp]");
    var jsonEl = document.getElementById("ProductJson");
    if (!root || !jsonEl) return;
    var product; try { product = JSON.parse(jsonEl.textContent); } catch (e) { return; }
    var selected = {};
    var first = product.variants.filter(function (v) { return v.available; })[0] || product.variants[0];
    if (!first) return;
    product.options.forEach(function (n, i) { selected[n] = first.options[i]; });
    var qty = 1;
    var addBtn = root.querySelector("[data-pdp-add]");
    var priceEl = root.querySelector("[data-pdp-price]");
    var soldEl = root.querySelector("[data-pdp-soldout]");
    var qtyEl = root.querySelector("[data-pdp-qtyval]");

    function findVariant() {
      return product.variants.find(function (v) { return product.options.every(function (n, i) { return v.options[i] === selected[n]; }); });
    }
    function available(name, value) {
      return product.variants.some(function (v) {
        return v.available && v.options[product.options.indexOf(name)] === value &&
          product.options.every(function (n, i) { return n === name || v.options[i] === selected[n]; });
      });
    }
    function update() {
      root.querySelectorAll("[data-opt-pill]").forEach(function (b) {
        var n = b.getAttribute("data-opt-name"), val = b.getAttribute("data-opt-value");
        b.classList.toggle("is-active", selected[n] === val);
        b.classList.toggle("is-unavailable", !available(n, val) && selected[n] !== val);
        var head = root.querySelector('[data-opt-selected="' + n + '"]');
        if (head) head.textContent = selected[n];
      });
      var v = findVariant();
      if (v) {
        if (priceEl) priceEl.textContent = money(v.price);
        if (addBtn) { addBtn.disabled = !v.available; addBtn.setAttribute("data-variant-id", v.id); }
        if (soldEl) soldEl.style.display = v.available ? "none" : "block";
      } else if (addBtn) { addBtn.disabled = true; }
    }
    root.addEventListener("click", function (e) {
      var pill = e.target.closest("[data-opt-pill]");
      if (pill) { selected[pill.getAttribute("data-opt-name")] = pill.getAttribute("data-opt-value"); update(); return; }
      var dec = e.target.closest("[data-pdp-qty='-1']"), inc = e.target.closest("[data-pdp-qty='1']");
      if (dec) { qty = Math.max(1, qty - 1); if (qtyEl) qtyEl.textContent = qty; }
      if (inc) { qty = qty + 1; if (qtyEl) qtyEl.textContent = qty; }
      var thumb = e.target.closest("[data-pdp-thumb]");
      if (thumb) {
        var main = root.querySelector("[data-pdp-main]");
        if (main) main.src = thumb.getAttribute("data-full");
        root.querySelectorAll("[data-pdp-thumb]").forEach(function (t) { t.classList.remove("is-active"); });
        thumb.classList.add("is-active");
      }
      var add = e.target.closest("[data-pdp-add]");
      if (add && !add.disabled) {
        var vid = add.getAttribute("data-variant-id");
        addToCart(vid, qty).then(function () { toast("Added to cart", qty + " × " + product.title); openSheet("cart"); })
          .catch(function (err) { toast("Error", err.message); });
      }
    });
    update();
  }

  /* ---------------- delegated global handlers ---------------- */
  document.addEventListener("click", function (e) {
    var openT = e.target.closest("[data-open-sheet]");
    if (openT) { e.preventDefault(); openSheet(openT.getAttribute("data-open-sheet")); return; }
    var closeT = e.target.closest("[data-close-sheet]");
    if (closeT) { e.preventDefault(); closeSheet(closeT.getAttribute("data-close-sheet")); return; }
    if (e.target.closest("[data-sheet-overlay]")) {
      var ov = e.target.closest("[data-sheet-overlay]");
      if (e.target === ov) { closeSheet(ov.getAttribute("data-sheet-overlay")); return; }
    }

    var qa = e.target.closest("[data-quickadd]");
    if (qa) { e.preventDefault(); openQuickAdd(qa.getAttribute("data-handle")); return; }

    // quick-add internal
    var qv = e.target.closest("[data-qa-variant]");
    if (qv) { qaState.variantId = parseInt(qv.getAttribute("data-qa-variant"), 10); renderQuickAdd(); return; }
    var qq = e.target.closest("[data-qa-qty]");
    if (qq) { qaState.qty = Math.max(1, qaState.qty + parseInt(qq.getAttribute("data-qa-qty"), 10)); var qv2 = document.querySelector("[data-qa-qtyval]"); if (qv2) qv2.textContent = ("0" + qaState.qty).slice(-2); return; }
    var qd = e.target.closest("[data-qa-dot]");
    if (qd) {
      var di = parseInt(qd.getAttribute("data-qa-dot"), 10) || 0;
      qaState.imgIdx = di;
      var trk = document.querySelector('[data-sheet="quickadd"] [data-qa-track]');
      if (trk) trk.scrollTo({ left: di * trk.clientWidth, behavior: "smooth" });
      document.querySelectorAll('[data-sheet="quickadd"] [data-qa-dot]').forEach(function (d, idx) { d.classList.toggle("is-active", idx === di); });
      return;
    }
    var qadd = e.target.closest("[data-qa-add]");
    if (qadd) {
      addToCart(qaState.variantId, qaState.qty).then(function () {
        toast("Added to Bag", qaState.qty + " × " + qaState.product.title);
        closeSheet("quickadd"); openSheet("cart");
      }).catch(function (err) { toast("Error", err.message); });
      return;
    }

    // cart line controls
    var rm = e.target.closest("[data-line-remove]");
    if (rm) { changeLine(rm.getAttribute("data-line-remove"), 0); return; }
    var qbtn = e.target.closest("[data-line-key]");
    if (qbtn) { changeLine(qbtn.getAttribute("data-line-key"), parseInt(qbtn.getAttribute("data-line-qty"), 10)); return; }

    if (e.target.closest("[data-checkout]")) { e.preventDefault(); window.location.href = "/checkout"; return; }
  });

  document.addEventListener("DOMContentLoaded", function () {
    initPDP();
    refreshCart();
  });
})();
